module.exports = __webpack_public_path__ + "../resources/images/like-60dd06f572dd67d908788f8b56018537.svg";